export const chatTypes = {
    ADD_CHAT_MESSAGE:'ADD_CHAT_MESSAGE',
    SET_MESSAGE:'SET_MESSAGE',
    GET_MESSAGES:'GET_MESSAGES',
    SET_MESSAGES:'SET_MESSAGES',
    SET_MESSAGES_FAILED: 'SET_MESSAGES_FAILED'
}